export enum InsetBottomType {
  None = 'none',
  BottomButton = 'bottomButton',
}
